<mat-card class="p-0">
  <div class="table-responsive" [hidden]="isCreateAvailability">
    <table
      mat-table
      multiTemplateDataRows
      [dataSource]="availabilitydataSource"
      class="mat-elevation-z1 overflow-hidden"
    >
      <!--- Note that these columns can be defined in any order.
                     The actual rendered columns are set as a property on the row definition" -->

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>No.</th>
        <td
          mat-cell
          *matCellDef="let element; let i = dataIndex"
          class="font-size-lg mb-0"
        >
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="day">
        <th mat-header-cell *matHeaderCellDef>Day</th>
        <td mat-cell *matCellDef="let element" class="font-size-lg mb-0">
          {{ element.text }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="availability_displayedColumns.length"
        >
          <div class="example-element-detail">
            <h4
            *ngIf="TimeSlots"
              class="subtable_header mt-3 mb-0 font-weight-bold font-size-h5 text-left text-dark text-hover-primary"
            >
              Time Slots
            </h4>

            <div class="mb-3" *ngIf="TimeSlots">
              <h5 class="text-left" *ngIf="element.timing.slot.length < 1">
                No Record!...
              </h5>
              <mat-chip-list aria-label="Time selection" class="mb-3">
                <mat-chip
                  class="mat-standard-chip-secondary"
                  *ngFor="let slot of element.timing.slot; index as k"
                  selected
                  color="default"
                >
                  {{ todayDate + ' ' + slot.from_time | date: 'h:mm a' }} -
                  {{ todayDate + ' ' + slot.to_time | date: 'h:mm a' }}
                </mat-chip>
              </mat-chip-list>
            </div>

            <h4
            *ngIf="QueueSlots" class="subtable_header mt-3 mb-0 font-weight-bold font-size-h5 text-left text-dark text-hover-primary"
            >
              Queue Slots
            </h4>

            <div class="mb-3" *ngIf="QueueSlots">
              <h5 class="text-left" *ngIf="element.timing.queue.length < 1">
                No Record!...
              </h5>
              <mat-chip-list aria-label="Queue selection">
                <mat-chip
                  class="mat-standard-chip-primary"
                  *ngFor="let slot of element.timing.queue; index as k"
                  selected
                  color="default"
                >
                  {{ todayDate + ' ' + slot.from_time | date: 'h:mm a' }} -
                  {{ todayDate + ' ' + slot.to_time | date: 'h:mm a' }}
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="textaligncenter">
          Actions
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="text-center">
            <button
              mat-icon-button
              *ngIf="expandedElement != element"
              [class.expanded]="expandedElement == element"
              (click)="expandedElement = element"
            >
              <span class="material-icons" matTooltip="View Timing"> remove_red_eye </span>
            </button>
            <button
              mat-icon-button
              *ngIf="expandedElement == element"
              [class.expanded]="expandedElement == undefined"
              (click)="expandedElement = undefined"
            >
              <span class="material-icons" matTooltip="Close Timing"> close </span>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="availability_displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: availability_displayedColumns"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'"
        style="overflow: hidden"
      ></tr>
    </table>

    <div
      [ngClass]="
      availabilitydataSource.filteredData? availabilitydataSource.filteredData.length > 0
          ? 'display-none'
          : 'visible:':'visible'
      "
    >
      <h4 align="center">No Record found.</h4>
    </div>

  </div>
</mat-card>
